import _ from 'lodash'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { getTestServersText, increaseCounter } from '../../../../data'
import { actions, selectors } from '../../../../imports'
import TestServers from './component'

// Todo: do these selectors rather belong in the Backend feature...?
const getExtraServers = state =>
    _.omit(selectors.getSimplifiedServers(state), selectors.getDefaultServer(state))
const getServers = createSelector(
    [getExtraServers, selectors.getTestServers],
    (servers, testServers) =>
        _.mapValues(servers, (name, serverId) => ({
            name,
            checked: testServers.indexOf(serverId) !== -1 || false,
        })),
)
const getExtraServerCount = createSelector([getExtraServers], servers => _.size(servers))

function mapStateToProps(state) {
    return {
        label: getTestServersText(state),
        servers: getServers(state),
        serverCount: getExtraServerCount(state),
        testServers: selectors.getTestServers(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        update: (testServers) => {
            dispatch(actions.setTestServers(testServers))
            dispatch(increaseCounter())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TestServers)



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/TestServers/index.js